var isSupported;
export var isWebpSupported = function () {
    if (isSupported !== undefined) {
        return isSupported;
    }
    try {
        var canvas = typeof document === 'object' ? window.document.createElement('canvas') : null;
        if (canvas === null) {
            isSupported = false;
            return isSupported;
        }
        canvas.width = canvas.height = 1;
        isSupported = canvas.toDataURL
            ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5
            : false;
    }
    catch (e) {
        isSupported = false;
    }
    return isSupported;
};
//# sourceMappingURL=is-webp-supported.js.map